<template>
  <div>
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <p class="primary--text mb-0" v-text="'圖片庫'" />
        <v-btn color="primary" @click="openFileInput()" v-text="'上傳圖片'" />
        <v-file-input
          id="upload_file_input"
          class="d-none"
          multiple
          accept="image/png, image/jpg, image/jpeg, image/gif"
          label="File input"
          @change="checkFileSize"
        />
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-0">
        <div class="d-flex pa-4 search-bar">
          <v-text-field
            v-model="search_keyword"
            outlined
            hide-details
            dense
            append-outer-icon="mdi-magnify"
            color="primary"
            placeholder="輸入圖片名稱搜尋"
            @keydown.enter="(e) => getImageGallery('search', e)"
            @click:append-outer="getImageGallery('search')"
          />
        </div>

        <v-divider />

        <v-data-table
          v-if="image_gallery_table_options.length"
          hide-default-footer
          :items-per-page="12"
          :headers="image_gallery_table_header"
          :items="image_gallery_table_options"
        >
          <template #[`item.image`]="{ item }">
            <div class="py-1">
              <v-img :id="`image_${item.id}`" contain :width="75" :height="75" :src="item.image" :alt="item.name" />
            </div>
          </template>

          <template #[`item.action`]="{ item }">
            <div class="d-flex justify-end">
              <v-btn
                class="mr-2 text_default btn_default btn_default_bg_linear"
                outlined
                @click="copyURL(item.image)"
                v-text="'複製連結'"
              />
              <v-btn class="btn-danger" @click="dialogSwitch('delete_image_dialog', item.id)" v-text="'刪除'" />
            </div>
          </template>

          <template #footer>
            <div v-if="image_gallery_table_options.length">
              <v-divider />

              <v-pagination
                v-model="pagination.page"
                class="py-4"
                :total-visible="8"
                :length="pagination.total"
                @previous="pagination.page - 1"
                @next="pagination.page + 1"
              />
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="loading_dialog" fullscreen :transition="false">
      <v-card class="d-flex align-center transparent">
        <v-card-text class="d-flex justify-center">
          <v-progress-circular indeterminate color="primary" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="exceed_limit_dialog">
      <v-card>
        <v-card-title class="primary white--text" v-text="'圖片檔案過大'" />
        <v-card-text class="py-4">
          <div v-for="(item, index) in exceed_limit_items" :key="index">
            <v-row no-gutters align="center">
              <v-col cols="2" class="d-flex justify-center">
                <v-img contain :max-width="100" :src="item.preview_url" :alt="item.name" />
              </v-col>
              <v-col cols="5">
                <p class="text-center" v-text="item.name" />
              </v-col>
              <v-col cols="5">
                <p class="text-center" v-text="`${(item.size / 1024 / 1024).toFixed(2)} MB`" />
              </v-col>
            </v-row>
            <v-divider v-if="index !== exceed_limit_items.length - 1" />
          </div>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn color="primary" @click="dialogSwitch('exceed_limit_dialog')" v-text="'確定'" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_image_dialog" max-width="600">
      <v-card>
        <v-card-title class="primary white--text" v-text="'刪除此圖片？'" />
        <v-card-text class="pt-5 text-subtitle-1">
          <p>確定刪除？一但刪除後將無法復原！</p>
          <v-checkbox v-model="curr_data.double_check" color="success">
            <template #label>
              <span
                class="font-weight-medium"
                :class="{ 'green--text': curr_data.double_check }"
                v-text="'我理解刪除後將無法復原，我仍要刪除！'"
              />
            </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="dialogSwitch('delete_image_dialog')" v-text="'取消'" />
          <v-btn class="white--text btn-danger" @click="deleteImage(curr_data.id)" v-text="'確定'" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { apiGetImageGallery, apiUploadImage, apiDeleteImage } from '@/api/common.js'

export default {
  name: 'ImageGallery',
  data() {
    return {
      pagination: {
        page: 1,
        total: 1,
      },
      loading_dialog: false,
      search_keyword: '',
      image_gallery_table_header: [
        {
          text: '圖片',
          value: 'image',
          sortable: false,
          width: '150px',
          class: 'font-weight-medium black--text',
        },
        {
          text: '圖片名稱',
          value: 'name',
          sortable: false,
          width: 200,
          class: 'font-weight-medium black--text',
        },
        {
          text: '上傳時間',
          value: 'upload_time',
          sortable: false,
          width: 200,
          class: 'font-weight-medium black--text',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          width: 200,
          class: 'font-weight-medium black--text',
        },
      ],
      image_gallery_table_options: [],
      exceed_limit_dialog: false,
      exceed_limit_items: [],
      delete_image_dialog: false,
      curr_data: {},
    }
  },
  watch: {
    search_keyword: {
      handler(newValue) {
        if (!newValue) {
          this.getImageGallery()
        }
      },
    },
    'pagination.page': {
      handler(newValue) {
        this.getImageGallery('pagination', newValue)
      },
    },
  },
  created() {
    this.getImageGallery()
  },
  methods: {
    async getImageGallery(type, data) {
      try {
        this.dialogSwitch('loading_dialog')
        // 確保中文輸入法選字時不會被觸發
        if (data?.isComposing) {
          return
        }

        const params = {
          source: 'optimize99',
          category: this.$route.params.container_id,
          group_id: '', // TODO: group_id 暫時寫死,
          limit: 12,
          name: type === 'search' ? this.search_keyword : '',
          page: type === 'pagination' ? data : 1,
        }

        const res = (await apiGetImageGallery(params)).image
        if (!res.content.length) {
          this.image_gallery_table_options = []
          return this.$root.vtoast.show({ message: '圖片庫無資料', color: 'primary' })
        }

        this.pagination.total = res.totalPages
        this.image_gallery_table_options = await res.content.map((item) => ({
          image: `${process.env.VUE_APP_IMG_CDN_ENDPOINT}api/${item.avatar_path}`.replace('avatar', 'cmp'),
          name: item.origin_name,
          upload_time: this.$utils.timeFormatMonitor(item.created_at),
          id: item.id,
          action: '',
        }))
      } catch (error) {
        console.log('getImageGallery() ERROR :', error)
        this.$root.vtoast.show({ message: '取得圖片庫資料失敗', color: 'error' })
      } finally {
        this.dialogSwitch('loading_dialog')
      }
    },
    async updateImage(file) {
      try {
        this.dialogSwitch('loading_dialog')
        const data = {
          category: this.$route.params.container_id,
          group_id: '', // TODO: group_id 暫時寫死
          file,
        }
        const payload = new FormData()
        for (const key in data) {
          payload.append(key, data[key])
        }

        await apiUploadImage(payload)
        this.$root.vtoast.show({ message: '上傳成功', color: 'primary' })
      } catch (error) {
        console.log('updateImage() ERROR :', error)
        this.$root.vtoast.show({ message: '上傳失敗', color: 'error' })
      } finally {
        this.dialogSwitch('loading_dialog')
      }
    },
    async deleteImage(id) {
      try {
        this.dialogSwitch('loading_dialog')
        if (!this.curr_data.double_check) {
          return this.$root.vtoast.show({
            message: '請勾選 「我理解刪除後將無法復原，我仍要刪除！」 才可執行刪除',
            color: 'error',
          })
        }

        await apiDeleteImage(id)
        this.dialogSwitch('delete_image_dialog')
        this.$root.vtoast.show({ message: '刪除成功', color: 'primary' })
        this.getImageGallery()
      } catch (error) {
        console.log('deleteImage() ERROR :', error)
        this.$root.vtoast.show({ message: '刪除失敗', color: 'error' })
      } finally {
        this.dialogSwitch('loading_dialog')
      }
    },
    copyURL(url) {
      console.log('url', url)
      const text = url.replace('avatar', 'cmp')
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$root.vtoast.show({ message: '連結已複製到剪貼板', color: 'primary' })
        })
        .catch(() => {
          this.$root.vtoast.show({ message: '複製失敗', color: 'error' })
        })
    },
    openFileInput() {
      document.getElementById('upload_file_input').click()
    },
    checkFileSize(files) {
      // 20MB = 20,971,520
      files.forEach(async (item, index) => {
        if (item.size > 20971520) {
          item.preview_url = URL.createObjectURL(item)
          this.exceed_limit_items.push(item)
        } else {
          await this.updateImage(item)
          if (index === files.length - 1) {
            document.getElementById('upload_file_input').value = ''
            setTimeout(() => {
              this.getImageGallery()
            }, 1000)
          }
        }
      })

      if (this.exceed_limit_items.length) {
        this.dialogSwitch('exceed_limit_dialog')
        this.$root.vtoast.show({ message: '上傳失敗，檔案大小限制為10MB', color: 'error' })
      }
    },
    dialogSwitch(type, data) {
      if (type === 'delete_image_dialog' && data) {
        this.curr_data.id = data
      }

      if (type === 'exceed_limit_dialog' && this[type]) {
        this.exceed_limit_items = []
      }

      this[type] = !this[type]

      if (type !== 'loading_dialog' && !this[type]) {
        this.curr_data = {}
      }
    },
  },
}
</script>

<style scoped>
.search-bar {
  width: 33%;
}
</style>
